import React from 'react'
import ReactDOM from 'react-dom'
import classes from './loader.module.css'


const Loader = () => {
  return (
    <>
      {ReactDOM.createPortal(
        <div className={classes.loader}>
          <div className={classes.spinner}></div>
        </div>,
        document.getElementById("loader")
      )}
    </>
  );
}

export default Loader